<edit-asset-form-label
  htmlFor="create-asset-form-data-category"
  [ctrl]="control"
  [label]="label"></edit-asset-form-label>
<mat-form-field class="w-full" color="accent">
  <mat-select
    id="create-asset-form-data-category"
    placeholder="Select data category..."
    [formControl]="control"
    [compareWith]="'id' | compareByField">
    <mat-option [value]="null"></mat-option>
    <mat-option *ngFor="let item of items" [value]="item">
      {{ item.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
